document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.cart-drawer__item__title .item-title').forEach(function(item) {
    if (item.textContent.includes('Holiday Gift Wrap')) {
      var quantityElement = item.closest('.cart-drawer__item').querySelector('.cart-drawer__item__quantity');
      if (quantityElement) {
        quantityElement.remove();
      }
    }
  });
});
var observer1 = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
      if (mutation.target.classList.contains('state--cart-drawer-open')) {
        document.querySelectorAll('.cart-drawer__item__title .item-title').forEach(function(item) {
          if (item.textContent.includes('Holiday Gift Wrap')) {
            var quantityElement = item.closest('.cart-drawer__item').querySelector('.cart-drawer__item__quantity');
            if (quantityElement) {
              quantityElement.remove();
            }
          }
        });
      }
    }
  });
});

observer1.observe(document.documentElement, {
  attributes: true,
  attributeFilter: ['class']
});


document.addEventListener('DOMContentLoaded', function () {
  const toggleButton = document.querySelector('.filter-icon');
  const filterOptions = document.querySelector('.filter__group');
  if(toggleButton && filterOptions) {
    toggleButton.addEventListener('click', function () {
      filterOptions.classList.toggle('filter-visible');
    });
  }
});